import { useQuery } from "@apollo/client";
import { queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import { useMemo } from "react";
const { searchTMDB } = queries.tmdb;
/**
 * useTMDBSearch
 *
 * @description Hook to search TMDB for movies and TV shows
 * @param {Props} props - The properties for the hook
 * @param {string} props.query - The search query
 * @param {"movie" | "tv" | "both"} props.type - The type of content to search for
 * @returns {UseTMDBSearchReturn} - Loading state, error, and search results
 *
 */
const useTMDBSearch = ({ query, type = "both" }) => {
    const { loading, error, data } = useQuery(searchTMDB, {
        variables: {
            query,
            type: type === "both" ? "BOTH" : type.toUpperCase(),
            page: 1
        },
        skip: !query || query.length < 2,
        fetchPolicy: "cache-and-network"
    });
    // Transform GraphQL TMDBSearchResult to frontend-types TMDBSearchDropdownItem
    const results = useMemo(() => data?.searchTMDB?.map((item) => ({
        id: item.id.toString(),
        title: item.title,
        year: item.year,
        mediaType: item.mediaType,
        poster: item.poster,
        overview: item.overview,
        externalIds: item.externalIds?.imdbId
            ? { imdbId: item.externalIds.imdbId }
            : undefined
    })) ?? [], [data]);
    return {
        loading,
        error,
        data: results
    };
};
export default useTMDBSearch;
